import { render, staticRenderFns } from "./ValidatPass.vue?vue&type=template&id=35d2ade0&"
import script from "./ValidatPass.vue?vue&type=script&lang=js&"
export * from "./ValidatPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports